"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How does the 7-day free trial work?",
  answer: "You get full access to our AI website builder and managed hosting for a week. No credit card is required to start. If you love your new site, simply choose a plan to keep it live after the trial ends."
}, {
  question: "Can I migrate my existing WordPress site to Webshingle?",
  answer: "Yes! Our support team handles hosting migrations for free. We'll move your existing content, images, and SEO settings to our fast, managed WordPress environment without any downtime."
}, {
  question: "What happens when my AI credits run out?",
  answer: "AI credits for content and image generation renew every month based on your plan level. If you need more immediately, you can top up your credits at any time from your dashboard."
}, {
  question: "Is the hosting included in the monthly price?",
  answer: "Absolutely. Every Webshingle plan includes high-performance managed WordPress hosting, SSL certificates, and daily backups so you never have to worry about technical maintenance."
}, {
  question: "Do I own the website and content I create?",
  answer: "Yes, you have 100% ownership of your website, its design, and all AI-generated content. You can export your site or move it to another provider at any time if you choose to leave."
}];
export default function CommonQuestionsFaq() {
  return <section data-section-id="257395" id="common-questions" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container max-w-4xl">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold text-secondary md:text-4xl lg:text-5xl tracking-tight">
            Common Questions
          </h2>
        </div>

        <Accordion type="single" collapsible defaultValue="item-0" className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border bg-card rounded-lg shadow-md overflow-hidden">
              <AccordionTrigger className="px-6 py-5 text-left font-default text-base font-bold text-secondary hover:no-underline md:text-lg [&[data-state=open]>svg]:text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 pt-0 text-base leading-relaxed text-muted-foreground font-sans">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}